import styled, {css} from 'styled-components'

export const StyledDot = styled.span(
    ({theme: {palette, spacing}}) => css`
        width: 8px;
        height: 8px;
        background-color: ${palette.warning[500]};
        border-radius: 50%;
        margin-left: ${spacing}px;
    `
)

export const StyledText = styled.span(
    ({theme: {palette, typography}}) => css`
        color: ${palette.neutral[600]};
        ${typography.textSm};
    `
)
